import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import "./LandingPage.css";

import ReactPixel from "react-facebook-pixel";

import { terms, privacy } from "../../config/terms.js";
import Einstein from "../../components/Einstein/Einstein.js";
import Loader from "../../components/Loader/Loader.js";
import { TypeAnimation } from "react-type-animation";
import SlotNumber from "../../components/SlotNumber/SlotNumber.js";

const pixelOptions = {
    autoConfig: false,
    debug: true,
};

export default function LandingPage() {
    const [showBtn, setShowBtn] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const [modalStarbox, setModalStarbox] = useState(false);
    const [modalTerms, setModalTerms] = useState(false);
    const [modalPrivacy, setModalPrivacy] = useState(false);

    const [modalVideo, setModalVideo] = useState(false);

    const [scrollHeight, setScrollHeight] = useState(0);

    const [isVisible, setIsVisible] = useState(false);

    const [content0, setContent0] = useState(false);

    const [youtubeVideo, setYoutubeVideo] = useState("");

    const containerRef = useRef(null);
    const landingJoin = useRef(null);

    var video1Timeout;
    var video2Timeout;

    useEffect(() => {
        ReactPixel.init("320984243594077", null, pixelOptions);
        ReactPixel.pageView();
    }, []);

    useEffect(() => {
        setIsVisible(
            scrollHeight >
                containerRef.current?.scrollHeight -
                    document.body.scrollHeight -
                    200
        );
        if (vid1Ref.current) {
            if (scrollHeight > document.body.scrollHeight - 200) {
                clearTimeout(video1Timeout);
                video1Timeout = setTimeout(() => {
                    setShowBtn(true);
                    setTimeout(() => {
                        // setShowVideo(true);
                        vid1Ref.current.play().catch(console.log);
                    }, 100);
                }, 100);
            } else {
                clearTimeout(video1Timeout);
                vid1Ref.current.pause();
                vid1Ref.current.currentTime = 0;
                setShowVideo(false);
                setShowBtn(false);
            }

            if (scrollHeight > document.body.scrollHeight * 2 - 300) {
                clearTimeout(video2Timeout);
                video2Timeout = setTimeout(() => {
                    vid2Ref.current.play().catch(console.log);
                }, 100);
            } else {
                clearTimeout(video2Timeout);
                vid2Ref.current.pause();
                vid2Ref.current.currentTime = 0;
            }

            if (scrollHeight < document.body.scrollHeight - 200) {
                setContent0(true);
            } else {
                setContent0(false);
            }
        }
    }, [scrollHeight, showBtn]);

    const vid1Ref = useRef(null);
    const vid2Ref = useRef(null);

    return (
        <>
            <img
                src="/img/landingpage/whatsapp.svg"
                className="landing-whatsapp"
                onClick={() => {
                    window.open(
                        "https://wa.me/5511953983688?text=Ol%C3%A1,%20Carlos!%20Tenho%20algumas%20d%C3%BAvidas%20sobre%20a%20franquia%20ou%20preciso%20de%20ajuda%20com%20algo.",
                        "_blank"
                    );
                }}
            />
            <div
                className={`terms-modal-bg ${modalStarbox ? "shown" : ""}`}
                onClick={() => setModalStarbox(false)}
            >
                <div
                    className={`terms-modal modal-starbox-container`}
                    onClick={(ev) => ev.stopPropagation()}
                >
                    {/* <div className="terms-modal-title">S T A R B O X</div> */}
                    <div className="terms-modal-container modal-starbox">
                        A{" "}
                        <img
                            className="popup-starbox-icon"
                            src="/img/landingpage/starbox.svg"
                        />{" "}
                        é uma tecnologia 100% desenvolvida pela Orizom, que tem
                        por finalidade a automação total da operação logística,
                        fazendo com que um pedido feito por um franqueado seja
                        finalizado em até 60 segundos nas dependências da
                        Orizom!
                        <br />
                        <br />
                        Para isso, ocorre a junção do AI-Stem (criando 100% a
                        oferta nos marketplaces e capturando o pedido quando
                        vendido, sem nenhuma intervenção humana) com o
                        acionamento do robô da{" "}
                        <img
                            className="popup-starbox-icon"
                            src="/img/landingpage/starbox.svg"
                        />{" "}
                        fazendo todo o processo de embalação do pedido.
                        <br />
                        <br />A Orizom é a primeira empresa do Mundo a
                        desenvolver uma tecnologia de automação 100% executada
                        por IA de uma operação logística no segmento de vendas!
                    </div>
                </div>
            </div>
            <div
                className={`terms-modal-bg ${modalTerms ? "shown" : ""}`}
                onClick={() => setModalTerms(false)}
            >
                <div
                    className={`terms-modal`}
                    onClick={(ev) => ev.stopPropagation()}
                >
                    <div className="terms-modal-title">Termos de uso</div>
                    <div className="terms-modal-container">{terms}</div>
                </div>
            </div>
            <div
                className={`terms-modal-bg ${modalPrivacy ? "shown" : ""}`}
                onClick={() => setModalPrivacy(false)}
            >
                <div
                    className={`terms-modal`}
                    onClick={(ev) => ev.stopPropagation()}
                >
                    <div className="terms-modal-title">Privacidade</div>
                    <div className="terms-modal-container">{privacy}</div>
                </div>
            </div>
            <div
                className={`landing-modal-bg ${modalVideo ? "shown" : ""}`}
                onClick={() => setModalVideo(false)}
            >
                <div className="landing-modal-video">
                    <div className="modal-video-close">✕</div>
                    <div className="modal-video-loading">
                        <Loader />
                    </div>
                    {modalVideo ? (
                        <iframe
                            src={`https://www.youtube.com/embed/${youtubeVideo}?rel=0&color=white&iv_load_policy=3`}
                            title="Orizom"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                            allowfullscreen={true}
                            autoPlay
                            muted
                        ></iframe>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <div
                className="landing-page-container"
                onScroll={(ev) => {
                    setScrollHeight(ev.target?.scrollTop);
                    // if (ev.target?.scrollTop > scrollHeight) window.scrollTo(0, 100);
                }}
                ref={containerRef}
            >
                <div className={`landing-page-navbar scrolled`}>
                    <picture>
                        <source
                            media="(min-width: 700px)"
                            srcset="/img/logo-orizom.svg"
                        />
                        <source
                            media="(max-width: 700px)"
                            srcset="/img/landingpage/mini-logo.svg"
                        />
                        <img
                            className="lading-orizom-logo"
                            src="/img/logo-orizom.svg"
                            alt="Logo da Orizom"
                        />
                    </picture>

                    <div
                        to="cadastro"
                        className="landing-btn signup"
                        onClick={() => {
                            landingJoin.current?.scrollIntoView();
                        }}
                    >
                        Seja um franqueado!
                    </div>
                    <Link to="login" className="landing-btn">
                        Entrar
                    </Link>
                    {/* <div>{scrollHeight}</div> */}
                </div>
                <div
                    className={`landing-page-content landing-page-content-0 ${
                        content0 ? "active" : ""
                    }`}
                >
                    {/* <picture>
                        <source media="(min-width: 700px)" srcset="/img/landingpage/capa1.png" />
                        <source media="(max-width: 700px)" srcset="/img/landingpage/landing1mobile.png" />
                        <img className="landing-background" src="/img/landingpage/capa1.png" />
                    </picture> */}

                    <svg
                        // xmlns="http://www.w3.org/2000/svg"
                        // fillRule="evenodd"
                        // clipRule="evenodd"
                        // imageRendering="optimizeQuality"
                        // shapeRendering="geometricPrecision"
                        // textRendering="geometricPrecision"
                        viewBox="0 0 2116.66 2116.66"
                        className="orizom-launch-icon"
                    >
                        <path
                            d="M1708.75 539.76c-4.48 52.29-27.55 99.28-62.58 134.31-39.15 39.15-93.25 63.37-152.99 63.37-59.74 0-113.83-24.23-152.98-63.37-39.16-39.15-63.38-93.24-63.38-152.97 0-59.75 24.22-113.86 63.37-153.01 39.15-39.15 93.25-63.38 152.99-63.38 17.51 0 34.65 2.12 51.12 6.11 10.72 2.6 21.12 5.99 31.14 10.11 3.45-2.54 7.72-4.04 12.33-4.04 11.52 0 20.87 9.34 20.87 20.87 0 11.52-9.35 20.87-20.87 20.87-11.01 0-20.03-8.54-20.81-19.35-8.84-3.6-17.99-6.56-27.4-8.84-14.78-3.57-30.31-5.48-46.38-5.48-54.16 0-103.19 21.96-138.68 57.44-35.48 35.49-57.43 84.53-57.43 138.7 0 54.14 21.96 103.17 57.44 138.65 35.49 35.48 84.52 57.44 138.67 57.44 54.15 0 103.19-21.95 138.67-57.44 31.56-31.56 52.42-73.82 56.65-120.87-5.97-3.67-9.95-10.26-9.95-17.78 0-11.53 9.35-20.88 20.87-20.88 11.52 0 20.87 9.35 20.87 20.88 0 8.17-4.7 15.24-11.54 18.66zM479.26 1174.64c.55 1.87.84 3.85.84 5.9 0 11.52-9.34 20.86-20.86 20.86-11.53 0-20.87-9.34-20.87-20.86 0-10.98 8.48-19.98 19.24-20.81 21.48-29.24 49.29-54.79 79.75-76.86 44.11-31.93 94.07-56.7 138.36-74.8 160.52-65.63 370.53-81.87 559.35-55.36 108.78 15.27 210.76 44.75 292.47 87.12 83.06 43.08 145.53 99.69 173.71 168.64 14.68 35.91 20.04 74.97 14.14 116.96-3.18 22.62-9.93 44.19-19.86 64.66-47.26 97.32-166.82 169.58-315.88 211.38-147.28 41.3-324 53.16-487.79 30.14-95.4-13.41-186.56-38.66-265.13-76.81-25.64-12.44-53.76-28.06-80.98-47.09-23-16.07-45.26-34.53-64.73-55.49l-.86.02c-11.52 0-20.87-9.35-20.87-20.87 0-11.52 9.35-20.87 20.87-20.87 11.52 0 20.87 9.35 20.87 20.87 0 1.18-.1 2.34-.29 3.46 18.05 19.39 38.7 36.49 60.02 51.39 25.79 18.03 52.72 32.96 77.38 44.93 76.06 36.93 164.54 61.41 257.31 74.44 160.3 22.53 333.15 10.95 477.11-29.41 142.2-39.87 255.61-107.5 299.32-197.5 8.76-18.06 14.71-37.04 17.5-56.85 5.23-37.29.54-71.85-12.4-103.49-25.63-62.69-83.75-114.86-161.47-155.17-79.07-41-178.12-69.57-284.03-84.44-184.73-25.93-389.73-10.24-545.89 53.61-42.48 17.36-90.42 41.14-132.8 71.82-28.21 20.43-53.87 43.89-73.53 70.48zM2016.7 1410.5c11.52 0 20.86 9.35 20.86 20.87 0 11.52-9.34 20.87-20.86 20.87l-.51-.01c-94.35 151.93-323.36 267.41-596.3 322.97-274.47 55.88-593.93 51.48-865.28-37.17-96.28-31.44-188.47-70.98-266.52-120.78-78.61-50.16-142.85-110.77-182.51-184.04-50.74-93.79-45.7-180.41-12.91-254.99 45.78-104.1 146.09-184.18 222.95-227.1 87.06-48.61 172.62-85.53 266.41-113.03 93.65-27.46 195.51-45.53 315.28-56.45 113.98-10.37 234.86-10.27 352.89.85 113.34 10.68 224.09 31.5 323.66 62.92 99.13 31.27 201.3 76.1 285.63 132.7 72.27 48.49 131.54 105.75 164.89 170.7 2.01 3.87 3.82 7.52 5.46 10.93 10.69.91 19.09 9.87 19.09 20.8 0 11.52-9.35 20.86-20.87 20.86-11.52 0-20.87-9.34-20.87-20.86 0-4.7 1.55-9.04 4.18-12.52-1.69-3.53-3.33-6.86-4.92-9.96-31.64-61.67-88.55-116.45-158.19-163.18-82.54-55.39-182.91-99.39-280.5-130.17-98.35-31.04-207.66-51.6-319.45-62.13-116.83-11-236.44-11.11-349.18-.85-118.36 10.79-218.96 28.63-311.41 55.74-92.31 27.07-176.56 63.42-262.3 111.29-74.03 41.35-170.53 118.21-214.24 217.61-30.47 69.28-35.09 149.85 12.2 237.26 37.9 70.04 99.72 128.23 175.55 176.62 76.38 48.74 167.05 87.57 261.92 118.56 267.98 87.55 583.66 91.85 855.01 36.61 267.59-54.48 491.51-166.59 582.88-313.41a20.773 20.773 0 01-2.91-10.64c0-11.52 9.34-20.87 20.87-20.87zM517.22 690.52c10.43 0 19.08 7.66 20.62 17.66 6.6 2.07 13.37 3.81 20.28 5.2 12.5 2.49 25.45 3.81 38.69 3.81 54.16 0 103.18-21.95 138.67-57.44 35.49-35.48 57.44-84.51 57.44-138.65 0-54.17-21.95-103.21-57.43-138.7-35.46-35.5-84.49-57.44-138.68-57.44-54.19 0-103.22 21.94-138.68 57.4-31.56 31.6-52.41 73.88-56.64 120.95a20.85 20.85 0 019.94 17.79c0 11.52-9.34 20.86-20.86 20.86-11.53 0-20.87-9.34-20.87-20.86 0-8.18 4.7-15.25 11.54-18.68 4.47-52.3 27.55-99.3 62.57-134.33 39.19-39.15 93.3-63.38 153-63.38 59.71 0 113.8 24.23 152.97 63.4 39.17 39.13 63.39 93.24 63.39 152.99 0 59.73-24.22 113.82-63.37 152.97-39.16 39.15-93.25 63.37-152.99 63.37-14.6 0-28.86-1.45-42.65-4.2-7.91-1.59-15.69-3.61-23.3-6.05a20.806 20.806 0 01-13.64 5.07c-11.52 0-20.87-9.34-20.87-20.87 0-11.52 9.35-20.87 20.87-20.87z"
                            className="svg-elem-1"
                        ></path>
                    </svg>

                    <div className="landing-content landing-0">
                        <div className="landing-text">
                            2° Evento de Lançamento do Ano!
                        </div>
                        <div
                            className="landing-watch-btn"
                            onClick={() => {
                                setYoutubeVideo("Dk18WBw4Owk");
                                setModalVideo(true);
                            }}
                        >
                            Assista ao evento!
                        </div>
                    </div>
                </div>
                <div
                    className={`landing-page-content ${
                        scrollHeight > document.body.scrollHeight - 200
                            ? "visible"
                            : ""
                    }`}
                >
                    {window.innerWidth > 700 ? (
                        <video
                            className={`landing-background landing-video ${
                                showVideo ? "" : "hidden"
                            }`}
                            src="/img/landingpage/desktop.mp4"
                            muted
                            loop
                            ref={vid1Ref}
                        />
                    ) : (
                        <video
                            className={`landing-background landing-video ${
                                showVideo ? "" : "hidden"
                            }`}
                            src="/img/landingpage/mobile.mp4"
                            muted
                            loop
                            ref={vid1Ref}
                        />
                    )}
                    <div className="landing-content">
                        {/* <img className="landing-aistem" src="/img/landingpage/aistem.svg" /> */}
                        {/* <Einstein className="landing-aistem" type="landing" /> */}
                        <div className="landing-text landing-text-first">
                            A 1ª Inteligência Artificial Generativa de
                            Dropshipping do Brasil!
                        </div>
                        {/* <TypeAnimation
                            key={1}
                            className={`landing-text`}
                            sequence={[
                                1500,
                                `A 1ª Inteligência Artificial Generativa de Dropshipping do Brasil!`,
                                200,
                                () => setShowBtn(true),
                                100,
                                () => setShowVideo(true),
                            ]}
                            speed={{
                                type: "keyStrokeDelayInMs",
                                value: 20,
                            }}
                        /> */}
                        <div
                            className={`landing-watch-btn ${
                                showBtn ? "" : "hidden"
                            }`}
                            onClick={() => {
                                setYoutubeVideo("IjVNVW4WEWk");
                                setModalVideo(true);
                            }}
                        >
                            Assista ao lançamento!
                        </div>
                    </div>
                </div>
                <div
                    className={`landing-page-content landing-page-content-2 ${
                        scrollHeight > document.body.scrollHeight * 2 - 300
                            ? "visible"
                            : ""
                    }`}
                >
                    {window.innerWidth > 700 ? (
                        <video
                            className={`landing-background landing-video-2 ${
                                showVideo ? "" : "hidden"
                            }`}
                            src="/img/landingpage/videostarbox.mp4"
                            muted
                            loop
                            ref={vid2Ref}
                        />
                    ) : (
                        <video
                            className={`landing-background landing-video-2 ${
                                showVideo ? "" : "hidden"
                            }`}
                            src="/img/landingpage/videostarbox.mp4"
                            muted
                            loop
                            ref={vid2Ref}
                        />
                    )}
                    <div className="landing-content landing-2">
                        <img
                            className="landing-starbox"
                            src="/img/landingpage/starbox.svg"
                        />
                        <div className="landing-text">
                            1ª Operação 100% automatizada (do mundo)!
                        </div>
                        <div
                            className="landing-watch-btn"
                            onClick={() => setModalStarbox(true)}
                        >
                            O que é?
                        </div>
                        <div
                            className="landing-watch-btn"
                            onClick={() => {
                                setYoutubeVideo("EWd-GTx3IwE");
                                setModalVideo(true);
                            }}
                        >
                            Assista na prática!
                        </div>
                    </div>
                </div>
                <div className={`landing-page-content visible`}>
                    <div className="landing-background-container">
                        <img
                            className="landing-background"
                            src="/img/landingpage/landing2.png"
                        />
                    </div>
                    <div className="landing-content landing-3">
                        {scrollHeight > document.body.scrollHeight * 3 - 400 ? (
                            <TypeAnimation
                                key={1}
                                className={`landing-text`}
                                sequence={[500, `PRODUTOS EXCLUSIVOS`]}
                                speed={{
                                    type: "keyStrokeDelayInMs",
                                    value: 20,
                                }}
                            />
                        ) : (
                            <></>
                        )}
                        {/* <div className="landing-text">PRODUTOS EXCLUSIVOS</div> */}
                    </div>
                </div>
                <div
                    className="landing-page-content landing-content-4"
                    ref={landingJoin}
                >
                    <div className="landing-content landing-4">
                        <div className="landing-text">
                            <div className="landing-price-title">
                                Torne-se um franqueado e pare de brigar por
                                preços!
                            </div>
                            <div className="landing-price-container">
                                <div className="landing-price">
                                    <span className="landing-price-value">
                                        <small>R$</small> 1.999,90
                                    </span>
                                    <small> /ano</small>
                                    <div className="landing-installments">
                                        Parcele em até 12x
                                    </div>
                                    <Link
                                        to="cadastro"
                                        className="landing-signup-btn"
                                    >
                                        Quero me tornar um franqueado!
                                    </Link>
                                </div>
                            </div>
                            <div className="landing-benefits">
                                <div className="landing-benefits-title">
                                    Principais vantagens:
                                </div>
                                <div className="landing-benefits-text">
                                    Tenha o Al-stem trabalhando por você 24/7
                                    sem parar!
                                    <br />
                                    Ele cria automaticamente seus anúncios,
                                    precifica, cria descrições altamente
                                    inteligentes, e quando você vender, ele
                                    captura automaticamente o pedido e o resto é
                                    com a Orizom!
                                    <br />
                                    <br />
                                    Tenha a{" "}
                                    <img
                                        className="popup-starbox-icon"
                                        src="/img/landingpage/starbox.svg"
                                    />{" "}
                                    cuidando dos seus pedidos e deixando-os
                                    prontos em até 60 segundos (a menor taxa de
                                    preparo desse segmento do Mundo)!
                                    <br />
                                    <br />
                                    Tenha a menor taxa de concorrência do
                                    Mercado! Abrimos apenas 50 vagas! Aqui você
                                    concorre com apenas 49 franqueados (para
                                    sempre)!
                                    <br />
                                    <br />
                                    Revenda produtos exclusivos!
                                    <br />
                                    Somos fabricantes enquanto 99% desse
                                    segmento são revendedores da indústria! Você
                                    busca exclusividade em produtos ou será mais
                                    um dentro do time da "briga de preços"?
                                    <br />
                                    <br />
                                    <div className="landing-bonus">
                                        <div className="landing-bonus-title">
                                            Bônus por vendas realizadas:
                                        </div>
                                        <span>10 vendas - </span>
                                        <strong>
                                            Ganhe R${" "}
                                            {isVisible && (
                                                <SlotNumber
                                                    number={100}
                                                    height={18}
                                                    delay={500}
                                                />
                                            )}
                                        </strong>
                                        <br />
                                        <span>100 vendas - </span>
                                        <strong>
                                            Ganhe R${" "}
                                            {isVisible && (
                                                <SlotNumber
                                                    number={500}
                                                    height={18}
                                                    delay={500}
                                                />
                                            )}
                                        </strong>
                                        <br />
                                        <span>1000 vendas - </span>
                                        <strong>
                                            Ganhe R${" "}
                                            {isVisible && (
                                                <SlotNumber
                                                    number={2500}
                                                    height={18}
                                                    delay={500}
                                                />
                                            )}
                                        </strong>
                                        <br />
                                        <span>5 mil vendas - </span>
                                        <strong>
                                            Ganhe R${" "}
                                            {isVisible && (
                                                <SlotNumber
                                                    number={5000}
                                                    height={18}
                                                    delay={500}
                                                />
                                            )}
                                        </strong>
                                        <br />
                                        <span>10 mil vendas - </span>
                                        <strong>
                                            Ganhe R${" "}
                                            {isVisible && (
                                                <SlotNumber
                                                    number={10000}
                                                    height={18}
                                                    delay={500}
                                                />
                                            )}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="landing-footer">
                            Copyright © 2018 - {new Date().getFullYear()} Orizom
                            Tecnologies Inc. (CNPJ 29.563.690/0001-79)
                            <div className="landing-footer-btns">
                                <span onClick={() => setModalTerms(true)}>
                                    Termos de uso
                                </span>
                                <span onClick={() => setModalPrivacy(true)}>
                                    Privacidade
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
